import WellknotLogo from "../assets/images/WellknotLTD.png";
import WetecLogo from "../assets/images/wetecai.png";

export const partners = [
  { id: 1, nameKey: "partners.wellknot", logo: WellknotLogo },
  { id: 2, nameKey: "partners.wetec", logo: WetecLogo },
];
